import React, { useState } from "react";
import { Award, Submission } from "../../types";
import moment from "moment";
import ResourceWrapper from "../ResourceWrapper";
import firebase from "firebase";
import { nanoid } from "nanoid";
import useAuth from "../../hooks/useAuth";
import Button from "../Button";

type RowProps = React.HTMLProps<HTMLButtonElement> & {
  submission: Submission;
  defaultStars?: number;
  variant?: "default" | "secondary";
  onSetSubmissions: (nextSubmission: Submission) => void;
};

const ActivitySubmissionRow = ({
  submission,
  defaultStars,
  onSetSubmissions,
}: RowProps) => {
  const [newAward, setNewAward] = useState({
    desc: `You have been awarded ${defaultStars} stars!`,
    stars: String(defaultStars),
  });
  const { accountDetails } = useAuth();

  const onMark = async () => {
    if (Number.isSafeInteger(Number(newAward.stars))) {
      const nextAward: Award = {
        id: nanoid(),
        seen: false,
        title: "Great job completing an activity!",
        description: newAward.desc,
        teacher: accountDetails?.name || accountDetails?.uid || "unknown",
        stars: Number(newAward.stars),
        date: Date.now(),
      };
      // Give student the award
      const studentDetails = await firebase
        .firestore()
        .collection("students")
        .doc(submission.userId)
        .get();

      firebase
        .firestore()
        .collection("students")
        .doc(submission.userId)
        .update({
          awards: [...(studentDetails.data()?.awards || []), nextAward],
        });
      // Update submission
      const nextSubmission: Submission = {
        ...submission,
        marked: true,
        markedBy: accountDetails?.name,
        stars: Number(newAward.stars),
      };
      firebase
        .firestore()
        .collection("submissions")
        .doc(submission.id)
        .update(nextSubmission);
      onSetSubmissions(nextSubmission);
    }
  };

  return (
    <tr>
      <td>{submission.userName}</td>
      <td>{submission.date && moment(submission.date).format("LLLL")}</td>
      {submission.string && <td>{submission.string}</td>}
      {submission.upload && (
        <td>
          <ResourceWrapper
            path={submission.upload?.path}
            name={submission.upload?.name}
            type={submission.upload?.type}
          />
        </td>
      )}
      {submission.marked ? (
        <td>
          Awarded {submission.stars} stars by {submission.markedBy || "unknown"}
        </td>
      ) : (
        <td>
          <textarea
            style={{ width: "100%", height: 64 }}
            value={newAward.desc}
            onChange={(e) => setNewAward({ ...newAward, desc: e.target.value })}
          />
          <input
            type="string"
            defaultValue={defaultStars}
            onChange={(e) =>
              setNewAward({ ...newAward, stars: e.target.value })
            }
          />
          <Button small onClick={() => onMark()}>
            Mark
          </Button>
        </td>
      )}
    </tr>
  );
};

export default ActivitySubmissionRow;
